import { InsurancePlan } from '../services/interfaces/insurance';

export interface PlanForUI {
  _id: number,
  id: string;
  title: string;
  description: string;
  content: string;
  image: string;
  price: string;
  period: string;
}

export const sortPlans = (
  plans: PlanForUI[],
  originalPlans: InsurancePlan[],
  sortKey: string,
  sortDirection: 'asc' | 'desc'
): PlanForUI[] => {
  const plansCopy = [...plans];

  if (sortKey === 'averagePrice') {
    return plansCopy.sort((a, b) => {
      const priceA = parseFloat(a.price.replace(/[^0-9.]/g, '')) || 0;
      const priceB = parseFloat(b.price.replace(/[^0-9.]/g, '')) || 0;
      return sortDirection === 'asc' ? priceA - priceB : priceB - priceA;
    });
  } else if (sortKey === 'deductibleIndividualInNetwork') {
    return plansCopy.sort((a, b) => {
      // Find the original plan to get detailed information
      const originalPlanA = originalPlans.find(p => p.uid === a.id);
      const originalPlanB = originalPlans.find(p => p.uid === b.id);

      // Extract deductible from the detailed coverage info
      const deductibleA = originalPlanA?.details?.coverage?.['Deductible (Individual) - In Network'] || 0;
      const deductibleB = originalPlanB?.details?.coverage?.['Deductible (Individual) - In Network'] || 0;

      // Convert to numbers if they are strings
      const numA = typeof deductibleA === 'string' ? parseFloat(deductibleA.replace(/[^0-9.]/g, '')) || 0 : deductibleA;
      const numB = typeof deductibleB === 'string' ? parseFloat(deductibleB.replace(/[^0-9.]/g, '')) || 0 : deductibleB;

      return sortDirection === 'asc' ? numA - numB : numB - numA;
    });
  } else if (sortKey === 'name') {
    return plansCopy.sort((a, b) => {
      const nameA = parseInt(a.title.match(/\d+/)?.[0] || '0', 10);
      const nameB = parseInt(b.title.match(/\d+/)?.[0] || '0', 10);
      return sortDirection === 'asc' ? nameA - nameB : nameB - nameA;
    });
  }

  // Default sorting: by price ascending (cheapest first)
  return plansCopy.sort((a, b) => {
    const priceA = parseFloat(a.price.replace(/[^0-9.]/g, '')) || 0;
    const priceB = parseFloat(b.price.replace(/[^0-9.]/g, '')) || 0;
    return priceA - priceB;
  });
};
